import { render, staticRenderFns } from "./IpWrapper.vue?vue&type=template&id=54a872b4&"
import script from "./IpWrapper.vue?vue&type=script&lang=js&"
export * from "./IpWrapper.vue?vue&type=script&lang=js&"
import style0 from "./IpWrapper.vue?vue&type=style&index=0&id=54a872b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports